import api from "../api";
import Swal from 'sweetalert2';
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    guest: '',
    session: {},
    address: {
      postcode: '',
      address: '',
      number: '',
      complement: '',
      state: '',
      city: '',
      district: '',
    },
    current_user: {},
    favorites: {},
  },
  getters: {
    getSession: () => JSON.parse(localStorage.getItem("session")),
    getFullname: () => JSON.parse(localStorage.getItem("session")).user.name + ' ' + JSON.parse(localStorage.getItem("session")).user.last_name,
    isAdmin: (state) => state.current_user.role == 'admin',
    isClient: (state) => state.current_user?.subscription?.active,
    isSupplier: (state) => state.current_user.role == 'supplier',
  },
  actions: {
    async login_keycloak({ commit }, payload) {
      try {

        const params = new URLSearchParams(window.location.search);
        let token = params.get("L1G4br4T0k3n2020En13F1");
        if(token){
          commit("CREATE_LOGIN", {token: token});
        }  
      } catch (e) {
        commit("ERROR_LOGIN", e);
      }
    },
    async login({ commit }, payload) {
      try {
        api.post("/login", payload)
          .then((res) => {
            commit("CREATE_LOGIN", res.data);
          })
          .catch((error) => {
            commit("ERROR_LOGIN", "Acesso negado");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_LOGIN", e);
      }
    },
    async logout({ commit }) {
      try {
        api.post("/v1/auth/logout")
          .then((res) => {
            commit("DESTROY_LOGIN", res.data);
          })
          .catch((error) => {
            commit("ERROR_LOGIN", "Acesso negado");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_LOGIN", "Acesso negado");
      }
    },
    async register({ commit }, payload) {
      try {
        return new Promise((resolve, reject) => {
          api.post("/register", { user: payload })
            .then((res) => {
              commit("CREATE_REGISTER", res.data);
            })
            .catch((error) => {
              if (error.response && error.response.status === 422) {
                const errorMessage = error.response.data.error;
                Swal.fire('Erro!', errorMessage, 'error');
              }
              // commit("ERROR_REGISTER", errorMessage);
              // reject(error);
            })
            .finally(() => {
              console.log('register request end');
            });
        });
      } catch (e) {
        commit("ERROR_REGISTER", "Acesso negado");
        throw e;
      }
    },
    async edit({ dispatch, commit }, payload) {
      try {
        return new Promise((resolve, reject) => {
          api.post("/v1/update-client", { user: payload })
            .then((res) => {

              //if (window.innerWidth < 480) {
              toast.success("Atualizado com sucesso", {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
              //}

              //dispatch("alert/set_alert", {alert_message: "Atualizado com sucesso", type_message: 'alert-success'}, { root: true });
              dispatch("get_current_user");
            })
            .catch((error) => {
              if (error.response && error.response.status === 422) {
                const errorMessage = error.response.data.error;
                Swal.fire('Erro!', errorMessage, 'error');
              }
              // commit("ERROR_REGISTER", errorMessage);
              // reject(error);
            })
            .finally(() => {
              console.log('register request end');
            });
        });
      } catch (e) {
        commit("ERROR_REGISTER", "Acesso negado");
        throw e;
      }
    },
    async buscarAddress({ commit }, cep) {
      return axios
        .get(`https://viacep.com.br/ws/${cep}/json/`)
        .then(response => {
          const address = {
            postcode: response.data.cep,
            address: response.data.logradouro,
            number: response.data.number,
            complement: response.data.complemento,
            state: response.data.uf,
            city: response.data.localidade,
            district: response.data.bairro,
          };
          commit('SET_ADDRESS', address);
          return address;
        })
        .catch(error => {
          console.error('Erro ao obter o endereço:', error);
          throw error;
        });
    },
    async get_current_user({ dispatch, commit }) {
      try {
        if (!localStorage.getItem("session"))
          return


        dispatch("validateToken");

        api.get("/v1/users/current-user")
          .then((res) => {
            commit("SET_USER", res.data);
          })
          .catch((error) => {
            console.log("current user", error)
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        console.log("loading current user", e);
      }
    },

    async set_guest_user({ commit }) {

      if (localStorage.getItem("session"))
        return

      if (localStorage.getItem("guest")) {
        commit("SET_GUEST", localStorage.getItem("guest"))
        return
      }
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      let counter = 0;
      while (counter < 20) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
      }
      localStorage.setItem("guest", result)
      commit("SET_GUEST", result)
    },

    async get_favorites({ commit }) {
      try {
        if (!localStorage.getItem("session"))
          return

        api.get("/v1/users/favorites")
          .then((res) => {
            commit("SET_FAVORITES", res.data);
          })
          .catch((error) => {
            console.log("current user", error)
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        console.log("loading current user", e);
      }
    },

    async add_to_favorite({ commit }, payload = []) {
      try {
        api.post(`/v1/favorites/add-to-favorite`, payload)
          .then((res) => {
            commit("ADD_TO_FAVORITE", res?.data);
          })
          .catch((error) => {
            console.log("ADD_TO_FAVORITE", error)
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        console.log("ADD_TO_FAVORITE", e)
      }
    },

    async refreshToken() {
      console.log("renovando token")
      try {
        api.post("/v1/refresh", {})
          .then((res) => {
            localStorage.setItem("session", JSON.stringify(res.data))
            localStorage.setItem("session_expire_at", JSON.stringify(new Date().toISOString()) )
          })
          .catch((error) => {
            commit("ERROR_LOGIN", "Acesso negado");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        console.log("ERRO REFRESH TOKEN", e)
      }
    },

    validateToken({ dispatch }) {
      const session_expire_at = JSON.parse(localStorage.getItem('session_expire_at'));
      if (session_expire_at) {
        const tokenCreatedAt = new Date(session_expire_at); // Timestamp salvo
        const now = new Date();
        const timeDifference = (now - tokenCreatedAt) / 1000 / 60 / 60; // diferença em horas
  
        if (timeDifference > 1) {
          dispatch("refreshToken");
        }
      }
    },

  },

  mutations: {
    SET_GUEST(state, result) {
      if (!state.guest)
        state.guest = result
    },
    CREATE_LOGIN(state, data) {
      localStorage.setItem("session", JSON.stringify(data))
      localStorage.setItem("session_expire_at", JSON.stringify(new Date().toISOString()) )

      window.location.href = '/';
    },
    ERROR_LOGIN(state, data) {
      console.log(data)
      state.session.error = data
    },
    DESTROY_LOGIN(state, data) {
      localStorage.removeItem("session")
      localStorage.removeItem("session_expire_at")
      localStorage.removeItem("tokenValidate")
      
      location.reload();
    },
    CREATE_REGISTER(state, data) {
      localStorage.setItem("session", JSON.stringify(data))
      localStorage.setItem("session_expire_at", JSON.stringify(new Date().toISOString()) )

      location.reload();
    },
    SET_ADDRESS(state, address) {
      state.address = address;
    },
    SET_FAVORITES(state, favorites) {
      state.favorites = favorites;
    },
    ADD_TO_FAVORITE(state, favorites) {
      state.favorites = favorites;
    },
    SET_USER(state, data) {
      state.current_user = data;
      // if(
      //   !data.role == 'admin' &&
      //   !data?.subscription?.active &&
      //   !data.role == 'supplier'
      // ){
      //   this.$router.push({ name: 'Planos' })
      // }
    },

  }
}